export interface SavedCard {
  token: string;
  default?: boolean;
  imageUrl?: string;
  cardType?: string;
  last4?: string;
  expirationDate?: string;
  cardholderName?: string;
}

export interface PaymentMethodsResponse {
  data?: SavedCard[];
}

interface TokenRecord {
  clientToken?: string;
  token?: string;
}

export interface ClientTokenResponse {
  data?: string | TokenRecord;
  clientToken?: string;
  token?: string;
}

export interface PaymentProfile {
  data?: {
    user?: {
      phoneNumber?: string;
      firstName?: string | null;
      email?: string | null;
    };
  };
}

export const readClientToken = (body: ClientTokenResponse): string | null => {
  const rawToken = body.data ?? body;
  if (typeof rawToken === 'string') return rawToken;
  if (rawToken && typeof rawToken === 'object') {
    return rawToken.clientToken ?? rawToken.token ?? null;
  }
  return null;
};
